module.exports = __webpack_public_path__ + "img/logo-autolac-laudos.7557874f.jpeg";